import { Image, StyleSheet, View } from 'react-native';

import ActionButtonLink from 'components/action-button';
import { Typography } from 'components/ui';
import { useIsDesktopLargeBreakpoint } from 'hooks/use-media-query';
import { t } from 'state/intl/translations';
import { spacing } from 'styles/constants';
import { routes } from 'utils/routing';

const crownImage = require('./gray-crown.png');

export const LoyaltyRewardsEmptyScreen = () => {
  const isDesktopLarge = useIsDesktopLargeBreakpoint();

  return (
    <View style={styles.wrapper}>
      <Image style={styles.image} source={crownImage} />
      <Typography
        variant="headerOne"
        fontSize={isDesktopLarge ? 30 : undefined}
        lineHeight={isDesktopLarge ? 36 : undefined}
        style={styles.title}
      >
        {t('rewardNotAvailable', 'Reward Not Available')}
      </Typography>
      <Typography variant="copyOne" textAlign="center" style={styles.description}>
        {t(
          'rewardNotAvailableDescription',
          `Rewards aren't available at your current location, but we're working to bring them to more places soon.`
        )}
      </Typography>
      <ActionButtonLink to={routes.menu}>
        {t('browseMenuInstead', 'Browse Menu Instead')}
      </ActionButtonLink>
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    alignItems: 'center',
    padding: 32,
  },
  image: {
    width: 173,
    height: 173,
  },
  title: {
    marginBottom: spacing.$4,
  },
  description: {
    marginBottom: spacing.$2,
  },
});
